import { render, staticRenderFns } from "./BackendLicensePreview.vue?vue&type=template&id=c4b5a2fa&scoped=true&lang=pug"
import script from "./BackendLicensePreview.vue?vue&type=script&lang=js"
export * from "./BackendLicensePreview.vue?vue&type=script&lang=js"
import style0 from "./BackendLicensePreview.vue?vue&type=style&index=0&id=c4b5a2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b5a2fa",
  null
  
)

export default component.exports